import styled from "styled-components";
import { VeryModal } from "../../common/v2/VeryModal";

const Modal = styled(VeryModal)`
  .divContentModal {
    width: 440px;
  }
  .divBodyModal {
    align-items: flex-start !important;
    gap: 14px;
    padding: 0px 3px 3px 3px;
  }
  .divButtons .btnModal {
    padding-top: 11px;
    padding-bottom: 11px;
    border-radius: 10px;
  }
`;

const Styles = { Modal };

export default Styles;
